import { render } from "./AkahonSideMenu.vue?vue&type=template&id=db39466e"
import script from "./AkahonSideMenu.vue?vue&type=script&lang=js"
export * from "./AkahonSideMenu.vue?vue&type=script&lang=js"

import "./AkahonSideMenu.vue?vue&type=style&index=0&id=db39466e&lang=css"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__